import moment from 'moment'
import cartObject from "@/model/cart";
export default {
  namespaced: true,
  state: {
    newCart: JSON.parse(JSON.stringify(cartObject)) ,
    expires_at: null,
    orderTotal: 0,
    postcode: ''
  },
  mutations: {
    SET_CART: (state, payload) => {
      state.newCart = {...state.newCart, ...payload}
    },
    SET_EXPIRATION: (state) => {
      state.expires_at = moment().add(30, 'minutes')
    },
    INIT_CART: (state, payload) => {
      state.expires_at = null
      state.newCart = {...state.newCart, ...payload} // init with default values
    },
    SET_ORDER_TOTAL: (state, _orderTotal) => {
      state.orderTotal = _orderTotal;
    },
    SET_POSTCODE:(state, postcode) => {
      state.postcode = postcode
    }
  },

  actions: {
    saveNewCart: ({ commit, state }, payload) => {

      commit('SET_CART', {...state.newCart, ...payload})
      commit('SET_EXPIRATION')
    },
    clearNewCart: ({ commit }) => {
      commit('INIT_CART', JSON.parse(JSON.stringify(cartObject)))
      commit('SET_ORDER_TOTAL', 0)
      commit('SET_EXPIRATION')
    },
    storeOrderTotal: ({ commit }, totalOrder) => {
      commit('SET_ORDER_TOTAL', totalOrder)
    },
    savePostcode:({ commit }, postcode) =>{
      commit('SET_POSTCODE', postcode)
    }
  }
}